export default "__VITE_ASSET__DBE2Zlnw__"